import { render, staticRenderFns } from "./collectList.vue?vue&type=template&id=7503b3bb&scoped=true"
import script from "./collectList.vue?vue&type=script&lang=js"
export * from "./collectList.vue?vue&type=script&lang=js"
import style0 from "./collectList.vue?vue&type=style&index=0&id=7503b3bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7503b3bb",
  null
  
)

export default component.exports